var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',_vm._g(_vm._b({attrs:{"type":_vm.type,"size":_vm.size,"loading":_vm.loading,"disabled":_vm.disabled,"round":_vm.round,"circle":_vm.circle,"icon":_vm.icon}},'el-button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }